<template> 
	<div :class="optionalClass">
	 	<svg class='load'>
            <circle cx='50%' cy='50%' r="42.5%" stroke-width="7.5%" fill='none'/>
        </svg>
    </div>
</template>
<script>
	export default {
        name: 'loadingGif',
        props: ['optionalClass']
    }
</script>